import { TableColumns } from '../../../../../ui-components/lib/table/table.model';

export const REQUEST_LIST_TAB_PARAM_KEY = 'view';

/** URL / payload key of the category chips filter. */
export const REQUEST_LIST_CATEGORY_FILTER_KEY = 'category_id';

/** UI_Version_2 list view; headers are translation keys. */
export const REQUEST_LIST_COLUMNS: TableColumns[] = [
  { identifier: 'number', header: '' },
  { identifier: 'workflow', header: 'requests_table_workflow_header' },
  { identifier: 'category', header: 'requests_table_category_header' },
  { identifier: 'actions', header: 'requests_table_actions_header' },
];
